//libs
import { useState } from 'react';

//hooks
import { useDebouncedSearch } from '../../../../util/misc';

//images
import SearchIcon from '../images/search.svg';
import CloseIcon from '../images/icon-close.svg';

export default function Search({
    search,
}: { search: string }) {
    const [inputValue, setInputValue] = useState(search);
    const inputSearch = useDebouncedSearch();

    return (
        <div className="search-form-v2">
            <label className="search-form-v2__inner">
                <input
                    className="search-form-v2__field" 
                    type="text" 
                    placeholder="Введите название партнёра, город или улицу для поиска"
                    onInput={inputSearch}
                    value={inputValue}
                    onChange={(e) => setInputValue(e?.target?.value)}
                />
                {inputValue ? (
                    <button
                        className="search-form-v2__clear"
                        onClick={() => {
                            setInputValue('');
                            inputSearch('');
                        }}    
                    >
                        <img 
                            src={CloseIcon}
                            alt="search-btn"
                        />
                    </button>
                ) : null}
                <button className="search-form-v2__sbmt">
                    <img 
                        src={SearchIcon}
                        alt="search-btn"
                    />
                </button>
            </label>
        </div>
    )
}